export const formatPhoneNumber = (value: any) => {
  let output = "(";
  value?.replace(
    /^\D*(\d{0,3})\D*(\d{0,3})\D*(\d{0,4})/,
    function (match: any, g1: any, g2: any, g3: any) {
      if (g1.length) {
        output += g1;
        if (g1.length === 3) {
          output += ")";
          if (g2.length) {
            output += " " + g2;
            if (g2.length === 3) {
              output += " - ";
              if (g3.length) {
                output += g3;
              }
            }
          }
        }
      }
    }
  );
  return output;
};

export const formatToE164 = (input: string): string => {
  // Remove all non-numeric characters except "+"
  const cleanedInput = input.replace(/[^0-9+]/g, "");

  // If the input starts with "+1", keep it as is
  if (cleanedInput.startsWith("+1")) {
    return cleanedInput;
  }

  // If the input starts with "+", don't add "+1"
  if (cleanedInput.startsWith("+")) {
    return cleanedInput;
  }

  // If the input is empty or partial, return it as is
  if (cleanedInput === "" || cleanedInput.length < 10) {
    return cleanedInput;
  }

  // Otherwise, add the "+1" prefix
  return `+1${cleanedInput}`;
};
